import React from "react";
import { Check, X } from "lucide-react";

interface DropdownOption {
  label: string;
  value: string;
}

interface DropdownProps {
  key?: string;
  value: string;
  options: string[] | DropdownOption[];
  onChange: (val: string) => void;
  onCancel?: () => void;
  onSubmit?: () => void;
  fullWidth?: boolean;
  label?: string;
  required?: boolean;
  optional?: boolean;
  disabled?: boolean;
}

const Dropdown: React.FC<DropdownProps> = ({
  key = "",
  value,
  options,
  onChange,
  onCancel,
  onSubmit,
  fullWidth = false,
  label = "",
  required = false,
  optional = false,
  disabled = false,
}) => {
  // normalize options into consistent structure
  const normalizedOptions: DropdownOption[] = Array.isArray(options)
    ? typeof options[0] === "string"
      ? (options as string[]).map((opt) => ({ label: opt, value: opt }))
      : (options as DropdownOption[])
    : [];

  return (
    <div
      key={key}
      className={`flex flex-col items-start space-y-1 ${
        fullWidth ? "w-full" : "w-auto"
      }`}
    >
      {label && (
        <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
          {label} {optional && <span>(optional)</span>}{" "}
          {required && <span className="text-red-600">*</span>}
        </label>
      )}

      <select
        className={`border rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 bg-white text-gray-900 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-100 dark:focus:ring-primary-500 dark:focus:border-primary-500 dark:disabled:bg-gray-900 disabled:cursor-not-allowed disabled:bg-gray-100 ${
          // fullWidth ? "w-full" : "w-auto"
          "w-full"
        }`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      >
        <option value="">Select</option>
        {normalizedOptions.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>

      <div className="flex space-x-2 mt-1">
        {onSubmit && (
          <button
            onClick={onSubmit}
            className="p-1 bg-green-100 text-green-700 rounded hover:bg-green-200 transition"
          >
            <Check size={14} />
          </button>
        )}
        {onCancel && (
          <button
            onClick={onCancel}
            className="p-1 bg-red-100 text-red-700 rounded hover:bg-red-200 transition"
          >
            <X size={14} />
          </button>
        )}
      </div>
    </div>
  );
};

export default Dropdown;
